export const AMENDMENT = 'amendment';
